<template>
  <div class="application-data">

    <div class="data-row application-row-gap">

      <div class="vertical-field">

        <div class="field-label">
          {{ fieldTitle(PassSectionFieldAliases.PASS_KIND, PassSectionsEnum.pass) }}
        </div>

        <div>{{ application.passKindName }}</div>

      </div>

      <div class="vertical-field">

        <div class="field-label">
          Временной интервал:
        </div>

        <div>
          {{ application.passAccessName }} c {{ application.time_of }} до {{ application.time_to }}
        </div>

      </div>

    </div>

    <div class="vertical-field">

      <div class="field-label">
        {{ fieldTitle(PassSectionFieldAliases.TERMINAL_SECTOR, PassSectionsEnum.pass) }}
      </div>

      <div class='reserve-height'>
        <template v-if='application.terminal_sectors.length === 0'>
          {{ application.terminalRegion.short_name || application.terminalRegion.name }}
        </template>
        <template v-else>
          <div>
            {{ application.terminalSectors.map((sector) => sector.short_name || sector.name).join(', ') }}
          </div>
        </template>
      </div>

    </div>

    <div class="vertical-field">

      <div class="field-label">
        Доступ на борт судов:
      </div>

      <div>
        {{ application.vesselAccessName }}
      </div>

    </div>

    <div v-if='currentVessel' class="application-vessel-row">

      <div class="field-label">
        Судно:
      </div>

      <div class="field-label">
        Флаг:
      </div>

      <div class="field-label">
        Причал:
      </div>

      <b-dropdown class='vessel-dropdown' :title='currentVessel.name'>
        <template #button-content>
          <div class="vessel-dropdown-btn">
            <div class='hide-extra-text'>{{ currentVessel.name }}</div> <i class='fa fa-caret-down'></i>
          </div>
        </template>
        <b-dropdown-item
          v-for='(vessel, index) in application.vessels'
          :key='index'
          @click='setVesselIndex(index)'
        >
          {{ vessel.name }}
        </b-dropdown-item>
      </b-dropdown>

      <div class='data-row application-vessel-flag-row-gap'>

        <img :src="currentVesselFlag" alt="" class='application-vessel-flag'>

        <div class='hide-extra-text' :title='currentVessel.vesselFlag.full_name'> {{ currentVessel.vesselFlag.full_name }}</div>

      </div>

      <div class='hide-extra-text' :title='currentVessel.berth'>
        {{ currentVessel.berth }}
      </div>

    </div>

    <div class="vertical-field">

      <div class="field-label">
        {{ fieldTitle(PassSectionFieldAliases.APPLICATION_PURPOSE, PassSectionsEnum.pass) }}
      </div>

      <div class='reserve-height'>{{ application.applicationGroupPurpose.name }}</div>

    </div>

    <div class="vertical-field">

      <div class="field-label">
        Вид деятельности:
      </div>

      <div class='activity' :title='application.applicationActivity'>{{ application.applicationActivity }}</div>

    </div>

    <div class="vertical-field">

      <div class="field-label">
        {{ fieldTitle(PassSectionFieldAliases.ADDITIONAL_PURPOSE, PassSectionsEnum.pass) }}
      </div>

      <div>
        {{ application.additional_purpose }}
      </div>

    </div>

    <div class='vertical-field'>

      <div class="field-label">
        {{ fieldTitle(PassSectionFieldAliases.TERMINAL_SUBDIVISION, PassSectionsEnum.pass) }}
      </div>

      <div>
        {{ application.terminalSubdivisionName }}
      </div>

    </div>

    <div v-for="(value, fieldName) in application.customFields" :key='fieldName' class="vertical-field">

      <div class="field-label">
        {{ fieldName }}
      </div>

      <div>
        {{ value }}
      </div>

    </div>

    <div v-if='visibleVisitorsCategoryField'>

      <div class="field-label">
        {{ fieldTitle(PassSectionFieldAliases.VISITORS_CATEGORY, PassSectionsEnum.pass) }}
      </div>

      <div>
        {{ application.visitors_category }}
      </div>

    </div>

    <div v-if='visibleTerminalIdField'>

      <div class="field-label">
        {{ fieldTitle(PassSectionFieldAliases.TERMINAL_ID, PassSectionsEnum.pass) }}
      </div>

      <div>
        {{ application.terminalName }}
      </div>

    </div>

    <div v-if='visibleAgentOrganizationField'>

      <div class="field-label">
        {{ fieldTitle(PassSectionFieldAliases.AGENT_ORGANIZATION, PassSectionsEnum.pass) }}
      </div>

      <div>
        {{ application.agentOrganizationName }}
      </div>

    </div>

  </div>
</template>

<script>
import applicationDataMixin from '../../../mixins/application-view/applicationDataMixin'
import { PassSectionFieldAliases } from '../../../enums/ApplicationSectionFieldAliases'
import PassSectionsEnum from '../../../enums/PassSectionsEnum'

export default {
  mixins: [applicationDataMixin],

  props: {
    application: {
      type: Object,
      required: true
    },

    baseUrl: {
      type: String,
      required: true
    },

    cfgFormFields: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      currentVesselIndex: 0
    }
  },

  computed: {
    PassSectionFieldAliases() {
      return PassSectionFieldAliases
    },

    PassSectionsEnum() {
      return PassSectionsEnum
    },

    currentVessel() {
      return this.application.vessels[this.currentVesselIndex]
    },

    currentVesselFlag() {
      return `${this.baseUrl}/img/icons/${this.currentVessel.vesselFlag.iso2}.svg`
    }
  },

  methods: {
    setVesselIndex(index) {
      this.currentVesselIndex = index
    }
  }
}
</script>

<style>
.application-data{
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
}

.application-row-gap {
  gap: 32px;
}

.reserve-height {
  min-height: 40px;
}

.application-vessel-row {
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: repeat(3, minmax(160px, 240px));
  column-gap: 32px;
  row-gap: 4px;
}

.vessel-dropdown, .application-vessel-dropdown {
  width: 100%;
}

.vessel-dropdown-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}

.vessel-dropdown > button, .vessel-dropdown > button:hover, .vessel-dropdown > button:focus {
  width: 100%;
  background-color: transparent;
  padding: 0;
  color: #337ab7;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.application-vessel-flag {
  width: 20px;
}

.application-vessel-flag-row-gap{
  gap: 8px;
}

.activity {
  max-height: 60px;
  overflow: hidden;
  line-height: 1.3;
}
</style>
